module.exports = __webpack_public_path__ + "static/img/db2.fb044761.jpg";